import DOMPurify from "dompurify";

// Sanityzacja HTML wstawianego przez dangerouslySetInnerHTML.
// Treść pochodzi z RichTextEditor (admin gminy) i jest renderowana na
// publicznej stronie — bez czyszczenia byłby to wektor stored XSS, gdyby
// konto admina zostało przejęte. DOMPurify usuwa <script>, atrybuty on*,
// javascript: URL itp. Whitelist tagów = formatowanie tekstu + linki.
const ALLOWED_TAGS = [
  "p", "br", "span", "strong", "b", "em", "i", "u", "s",
  "ul", "ol", "li", "a", "blockquote",
  "h1", "h2", "h3", "h4", "h5", "h6",
];
const ALLOWED_ATTR = ["href", "target", "rel"];

export function sanitizeHtml(raw: string): string {
  if (!raw) return "";
  return DOMPurify.sanitize(raw, { ALLOWED_TAGS, ALLOWED_ATTR });
}
